import React, { Component, ErrorInfo, ReactNode } from "react"
import { Alert } from "antd"
import * as Sentry from "@sentry/react"

interface Props {
    children: ReactNode
}

interface State {
    hasError: boolean
    error: Error | null
}

class ErrorBoundary extends Component<Props, State> {
    public state: State = {
        hasError: false,
        error: null,
    }

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error }
    }

    public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo)

        Sentry.withScope((scope) => {
            scope.setContext("react_error_boundary", {
                componentStack: errorInfo.componentStack,
            })
            Sentry.captureException(error)
        })

        this.setState({
            hasError: true,
            error: error,
        })
    }

    public render() {
        if (this.state.hasError) {
            return (
                <Alert
                    message='Ein Fehler ist aufgetreten'
                    description={
                        <>
                            Bitte versuchen Sie es später erneut oder kontaktieren Sie den Support.
                            {process.env.NODE_ENV === "development" && (
                                <div style={{ marginTop: "10px", fontSize: "12px", color: "#666" }}>
                                    {this.state.error?.message}
                                </div>
                            )}
                        </>
                    }
                    type='error'
                    showIcon
                />
            )
        }

        return this.props.children
    }
}

export default ErrorBoundary
